import React from "react";
import page_nav_icon_left from "../../../accerts/images/page_nav_icon_left.svg";
import page_nav_icon_right from "../../../accerts/images/page_nav_icon_right.svg";
import "./Pagination.css";

const Pagination = ({
  totalItems,
  currentPage,
  itemsPerPage,
  itemsPerPageOptions = [5, 10, 20, 50],
  onPaginationChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPaginationChange({
        currentPage: newPage,
        itemsPerPage,
      });
    }
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = Number(e.target.value);
    onPaginationChange({
      currentPage: 1, // Reset to first page
      itemsPerPage: newItemsPerPage,
    });
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      // Show ellipsis or pages around current page
      const leftBound = Math.max(2, currentPage - 1);
      const rightBound = Math.min(totalPages - 1, currentPage + 1);

      if (leftBound > 2) {
        pages.push("...");
      }

      for (let i = leftBound; i <= rightBound; i++) {
        pages.push(i);
      }

      if (rightBound < totalPages - 1) {
        pages.push("...");
      }

      // Always show last page
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="pagination-container">
      <div className="items-per-page">
        <span>Show</span>
        <select
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          aria-label="Items per page"
        >
          {itemsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            <img
              src={page_nav_icon_left}
              alt="Previous"
              style={{
                objectFit: "none",
                height: "40px",
                width: "35px",
              }}
            />
          </button>

          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() =>
                typeof page === "number" ? handlePageChange(page) : null
              }
              className={page === currentPage ? "active" : ""}
              disabled={page === "..."}
              aria-current={page === currentPage ? "page" : undefined}
            >
              {page}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            <img
              src={page_nav_icon_right}
              alt="Next"
              style={{
                objectFit: "none",
                height: "40px",
                width: "35px",
              }}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
